import { render, staticRenderFns } from "./EditMateria.vue?vue&type=template&id=1cb5c814&"
import script from "./EditMateria.vue?vue&type=script&lang=js&"
export * from "./EditMateria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports